<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B2.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                         <!-- 解决方案 -->
                         {{ $t('solution.solution_page_title') }}
                    </h1>
                    <h3>
                         <!-- 聚焦工业互联网行业，为企业提供360°解决方案，助力企业数字化转型升级，赋能中国制造业创新发展 -->
                        {{ $t('solution.solution_page_title') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                            {{ $t('solution.solution_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                             <!-- 解决方案 -->
                            {{ $t('solution.solution_breadcrumb_current') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      
        <section class="welcome-one">
			<div class="container">
                <!-- 工业互联网 -->
                <div class="row" >
                    <div class="container_row_title">
                            <h4 >
                                 <!-- 行业解决方案 -->
                                 {{ $t('solution.solution_industry_title') }}
                            </h4>
                    </div>
                    <div class=" wow fadeInUp row__item" v-for="(item,index) in solutionList" :key="index"  :data-wow-delay="(index+1)+'ms'" @click="handleDetail(item)" >
                        <div style="position: relative; display: block;margin: 10px;">
                            <img  :src="item.imgUrl" />
                            <h4 class="row__item_text_title">
                                <!-- {{ item.title }} -->
                                {{ $t(`solution.${item.i18n_title}`) }}
                                <!-- <p class="row__item_text_conter">{{ item.text }}</p> -->
                            </h4>
                        </div>
                    </div>
                </div>
			</div>
		</section>
     
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbSolutionList',
    mixins: [MixinsList],
    components: { },
    data () {
        return {
            routeList: [],  // 面包屑
            solutionList: [],
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {  },
    methods: {
       
        // 获取内容
        async getList() {
            // const { result } = res
            // this.solutionList = JSON.parse(JSON.stringify(result.programmeList))  
            try {
               const  result  = await loadData('solutionList', this.lang)
                this.solutionList = JSON.parse(JSON.stringify(result.programmeList)) 
            } catch (error) {
                console.log(error)
                this.solutionList= []
            }
        },
        // 详情
        handleDetail(item) {
            if(item.mbPath) {
                if(item.value) {
                    this.$router.push({
                        path: item.mbPath,
                        query: {
                            type: item.value
                        }
                    });
                } else {
                    this.$message.warning('暂时无法查看！');
                }
               
            }
         
          
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}
.welcome-one {
    background: var(--notech-extra);
    padding: 60px 0 60px; 
}

.row__item {
    cursor: pointer;
    position: relative;
    visibility: visible;
    animation-name: fadeInUp;

}
.col-xl-4 {
    padding: 0;
   
}
.row__item img {
    max-width: 100%;
}
.row__item h4 {
    font-size: var(--font-size-24);
    font-weight: bold;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    box-sizing: border-box;
    left: 0;
    line-height: 30px;
    background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.8));
    color: #FFFFFF;
    transition: all 0.6s;
}

/* .row__item:hover h4 {
    height: 100%;
    background: rgba(0,0,0,0.5);
    transition: all 0.6s;
    padding-top: 20px;
}
.row__item h4 p {
    font-size: var(--font-size-16);
    font-weight: 100;
    display: none;
    transition: all 0.4s;
    padding-right: 20px;
    line-height: 20px;
}
.row__item:hover h4 p{
    display: block;
    transition: all 6s;
    height: calc(100% - 55px);
    overflow: hidden;  
    text-overflow: ellipsis;
    -webkit-line-clamp: 9;
    -webkit-box-orient: vertical;
} */
.container_row_title h4{
    font-size: var(--font-size-40);
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.65;
    color: #232e5e;
}

.row__item_text {
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0;
    padding: 50px 30px;
    color: #FFFFFF;
    line-height: 2;
}
.row__item_text_title {

    font-size: var(--font-size-24);
    color: var(--notech-white);
}
.row__item_text_icon {
    font-size: var(--font-size-66);
   
}
.row__item_text_conter {
    /* margin-top: 15px;
     */
    font-size: var(--font-size-16);
    padding: 10px;
    width: 100%;
   
}
.icon_left{
    float: left;
    margin: 0 15px;
    margin-bottom: 50px;
}
.icon_right{
    float: right;
    margin: 0 15px;
    margin-bottom: 50px;
}

.welcome-two {
    padding: 30px 0 60px;
}
</style> 
